import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material'
import { FunctionComponent, useEffect } from 'react'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import { IPostManufacturer } from '../../../shared/services/manufacturer/manufacturer.model';
import ManufacturerService from '../../../shared/services/manufacturer/manufacturer.service';

export const ManufacturerDialog: FunctionComponent<{
  manufacturerId?: string,
  open: boolean,
  closeHandler: () => void,
  isEdit: boolean,
  isSubmitting: boolean,
  onSubmit: (values: IPostManufacturer, restForm: () => void, isEdit: boolean) => void,
}> = ({
  manufacturerId,
  open,
  closeHandler,
  isEdit,
  onSubmit,
  isSubmitting,
}) => {
    //Services
    const manufacturerService = new ManufacturerService()
    //Use Effects
    useEffect(() => {
      if (open && manufacturerId) {
        manufacturerService.getOne(manufacturerId)
          .then(response => {
            formik.setFieldValue('name', response.name)
          })
          .catch(err => console.log(err))
      }
    }, [open])

    const manufacturerSchema = Yup.object().shape({
      name: Yup.string().required('You must provide a manufacturer name'),
    })

    const formik = useFormik<IPostManufacturer>({
      initialValues: {
        name: '',
      },
      validationSchema: manufacturerSchema,
      onSubmit: (values) => {
        onSubmit(values, formik.resetForm, isEdit)
      }
    })

    const cancelHandler = () => {
      formik.resetForm()
      closeHandler()
    }

    return (
      <DialogWrapper
        open={open}
        onClose={closeHandler}
        title={!isEdit ? 'Add Manufacturer' : 'Edit Manufacturer'}
        cancelHandler={cancelHandler}
        submitHandler={formik.submitForm}
        isSubmitting={isSubmitting}>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Name</InputLabel>
          <OutlinedInput id='name'
            name='name'
            label='name'
            fullWidth
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            sx={{
              mr: 2
            }}></OutlinedInput>
          {formik.touched.name && formik.errors.name &&
            <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
              {formik.errors.name ? <div>{formik.errors.name as string}</div> : null}
            </FormHelperText>
          }
        </FormControl>
      </DialogWrapper>
    )
  }